<template>
  
  <div>
     
        <div class="user-profile">
        <div class="profile-card">
            <h1 class="profile-card__title clean-text-css" :style="options.titleStyle">{{ options.author.name }}</h1>
            <img class="profile-card__avatar" :src="options.author.thumbnail" :alt="'Avatar for' + options.author.name"/>
            <social-bar-clean 
            :facebook_url="options.author.facebook_url"
            :twitter_url="options.author.twitter_url"
            :instagram_url="options.author.instagram_url"
            :linkedin_url="options.author.linkedin_url"
            ></social-bar-clean>
        
        </div>
        <div class="profile-projects">
            <!-- <h2>Bart Veneman's projects</h2> -->
            <ol class="cards">
                <li v-for="post in options.posts" :key="post.id" style="overflow: hidden">
                    <a class="card" :href="'/' + post.url">
                        <h4 class="card__title clean-text-css">{{ post.title }}</h4>
                        <p class="card__meta"> {{ getFormatedDate(post.scheduled_date) }}
                        </p>
                    </a>
                </li>
                
            </ol>
        </div>
        </div>
  </div>

</template>

<script>

import SocialBarClean from './Snipets/SocialBarClean.vue';
import moment from 'moment/moment';


export default {
    props: ['options'],
    components: { SocialBarClean },
    name: 'ThemeAutor',
    data(){
        return {
            author: {},
            posts: []
        }
    },
    methods: {
        getFormatedDate(value){
            var locale = window.navigator.userLanguage || window.navigator.language;
            moment.locale(locale);
            return moment(String(value)).add(moment().utcOffset(), 'minutes').fromNow()
        }
    },
    mounted(){
        let vm = this;
        setTimeout(function(){
            let root = document.documentElement;
            root.style.setProperty('--details-color', vm.options.colorDetails);
            root.style.setProperty('--card-color', vm.options.cardBgColor);
        }, 1000)

    },
    watch: {
      options() {
        let root = document.documentElement;
        root.style.setProperty('--details-color', this.options.colorDetails);
            root.style.setProperty('--card-color', this.options.cardBgColor);

      }
    },
}
</script>

<style scoped>

/* @import url("https://fonts.googleapis.com/css?family=Teko:500"); */


.profile-card {
  background-color: var(--card-color);
  color: #050506;
padding-top: 100px;
/* padding-bottom: 50px; */
  text-align: center;
  background: linear-gradient(45deg, var(--card-color) calc(100% - 300px), var(--card-color) calc(100% - 300px),var(--card-color) calc(100% - 296px), var(--details-color) calc(100% - 296px));
}
@media (min-width: 800px) {
  .profile-card {
    padding-bottom: 25vmin;
  }
}
@media (max-width: 800px) {
  .profile-card {
      padding: 15vmin 20vmin;
  }
}
.profile-card__title {
  font-family: 'Teko';
  font-weight: 500;
  font-style: normal;
  text-decoration: none;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
  margin: 0;
  font-size: calc(28px + 8vmin);
}
.profile-card__subtitle {
  margin: 0;
  color: #615e6e;
  font-size: 18px;
  margin-bottom: 20px;
}
.profile-card__subtitle::before {
  content: '@';
}
.profile-card__avatar {
  display: inline-block;
  margin: 0;
  border-radius: 50%;
  border: 4px solid #fff;
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}
.profile-projects {
  background-color: var(--card-color);
  padding-bottom: 50px;
}
.cards {
  padding: 0 20px;
  list-style: none;
  max-width: 1200px;
  /* margin: 20px auto; */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(24ch, 1fr));
  grid-gap: 20px;
}
@media (min-width: 800px) {
  .cards {
    margin-top: -15vmin;
    grid-template-columns: repeat(auto-fit, minmax(28ch, 1fr));
  }
}
.card {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
          flex-direction: column;
  color: inherit;
  background-color: #fff;
  color: #1d1c21;
  text-decoration: none;
  padding: 20px;
  height: 8em;
  box-shadow: 0 2px 4px rgba(29,28,33,0.2);
}
.card:hover {
  background-color: #eae9ec;
}
.card:focus {
  outline: 2px solid #0d62e0;
}
.card:hover,
.card:focus {
  box-shadow: 0 2px 2px rgba(29,28,33,0.5);
}
.card__title {
  font-size: 18px;
  margin: 0;
}
.card__meta {
  margin: auto 0 0 0;
  color: #9491a1;
}


</style>